import React from 'react';
import PropTypes from 'prop-types';

import commonCss from './CreativeAsset.css';

const ImageAsset = React.forwardRef(({ url, onLoad, onError }, ref) => {
    return <img ref={ref} src={url} alt={url} className={commonCss.creativeAsset} onLoad={onLoad} onError={onError} />;
});

ImageAsset.propTypes = {
    url: PropTypes.string,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
};

export default ImageAsset;
